module.exports = __webpack_public_path__ + "img/bi.ac0f9815.svg";